export const REGULATORY_ACCEPT = 'REGULATORY_ACCEPT';
export const LOADED_CONSENT_REQUEST = 'LOADED_CONSENT_REQUEST';
export const OAUTH_LOGO_UPDATE = 'OAUTH_LOGO_UPDATE';

export interface OauthState {
  appLogo: string;
  client?: OauthClient;
  agreements?: string[];
  requestedScopes: string[];
  scopeDetails?: OauthScopeDetails;
}

interface OauthLogoUpdateAction {
  type: typeof OAUTH_LOGO_UPDATE;
  appLogo: string;
}

interface LoadedConsentRequestAction {
  type: typeof LOADED_CONSENT_REQUEST;
  client: OauthClient;
  agreements?: string[];
  requestedScopes: string[];
  scopeDetails: OauthScopeDetails;
}

interface LoadedRegulatoryAcceptAction {
  type: typeof REGULATORY_ACCEPT;
  agreements?: string[];
}

export type OauthActions =
  | LoadedConsentRequestAction
  | LoadedRegulatoryAcceptAction
  | OauthLogoUpdateAction;
